import { GenericDataApi } from '@/lib/data/GenericDataApi';

export class Terms extends GenericDataApi<any> {
    constructor() {
        super('Terms');
    }
}

export default new Terms();
